/**
 * Warning: this is a PARTIAL copy of "abcstrategie/cogaa" project's file.
 * Each update of the main project should be manually made.
 */
// import {Dialog, Toast} from 'buefy'
import {Toast} from 'buefy/dist/components/toast'
import {Dialog} from 'buefy/dist/components/dialog'
import client from './client'

export default class Utils {
  static username (name, lastname) {
    return `${this.slugify(name)}.${this.slugify(lastname)}`
  }
  static phone (tel, prefix = false) {
    let phone = tel.replace(/^\+[0-9]{2}/g, '')
    if (prefix) {
      return `${prefix}${phone}`
    }
    return phone
  }
  static slugify (string) {
    const specialChars = 'àáäâèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
    const normalChars = 'aaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
    // Replace special chars AND Replace "-" with "" AND Remove all non-word chars
    return string.toString().toLowerCase().replace(
      new RegExp(specialChars.split('').join('|'), 'g'),
      c => normalChars.charAt(specialChars.indexOf(c))
    ).replace(/-+/g, '').replace(/[^\w-]+/g, '')
  }
  static addLocale () {
    return 0 // 3600 * 2;
  }
  static now () {
    return this.timestamp(Date.now() + (this.addLocale() * 1000))
  }
  static tomorrow () {
    let tomorrow = new Date((this.now() + (24 * 60 * 60)) * 1000)
    tomorrow.setHours(0)
    tomorrow.setMinutes(0)
    tomorrow.setSeconds(0)
    tomorrow.setMilliseconds(0)
    return tomorrow
  }
  static timestamp (timestamp) {
    return parseInt(timestamp.toString().length === 13 ? (timestamp / 1000) : timestamp)
  }
  static date (timestamp) {
    timestamp = this.timestamp(timestamp) * 1000
    let date = new Date()
    date.setTime(timestamp)
    return date
  }
  /**
   *
   * @param date Date
   * @param separator
   * @returns {string}
   */
  static formatDateToYmd (date, separator = '-') {
    let month = `${date.getMonth() + 1}`
    let day = `${date.getDate()}`
    let year = date.getFullYear()
    if (month.length < 2) month = `0${month}`
    if (day.length < 2) day = `0${day}`
    return [year, month, day].join(separator)
  }
  /**
   *
   * @param date Date
   * @param separator
   * @returns {string}
   */
  static formatDateTodmY (date, separator = '-') {
    let month = `${date.getMonth() + 1}`
    let day = `${date.getDate()}`
    let year = date.getFullYear()
    if (month.length < 2) month = `0${month}`
    if (day.length < 2) day = `0${day}`
    return [day, month, year].join(separator)
  }
  /**
   * Open a prompt dialog with a message
   * @param {string} message     The message to display in the dialog.
   * @param {function} onConfirm Callback function for confirm button.
   * @param {function} onCancel  Callback function for cancel button.
   * @param {object} inputAttrs  Attributes for input.
   */
  static prompt (message, onConfirm, onCancel, inputAttrs) {
    inputAttrs = inputAttrs || {}
    Dialog.prompt({
      message,
      onConfirm,
      onCancel,
      inputAttrs,
      cancelText: 'Annulla',
      confirmText: 'Conferma',
      type: 'is-primary'
    })
  }
  /**
   * Open a confirm dialog with a message
   * @param {string} message     The message to display in the dialog.
   * @param {function} onConfirm Callback function for confirm button.
   * @param {function} onCancel  Callback function for cancel button.
   */
  static confirm (message, onConfirm, onCancel) {
    Dialog.confirm({
      message,
      onConfirm,
      onCancel,
      cancelText: 'Annulla',
      confirmText: 'Conferma',
      type: 'is-primary'
    })
  }
  /**
   * Use toast to show success messages.
   * @param message
   * @param modal
   */
  static success (message, modal = null) {
    // Close modal
    if (modal) {
      modal.close()
    }
    Toast.open({
      message,
      type: 'is-dark',
      position: 'is-bottom'
    })
  }
  /**
   * Use toast to show errors.
   * @param fail
   * @param modal
   */
  static errors (fail, modal = null) {
    let config = {
      type: 'is-danger',
      position: 'is-bottom'
    }
    // Close modal
    if (modal) {
      modal.close()
    }
    if (typeof fail.response !== 'undefined' &&
      typeof fail.response.data !== 'undefined' &&
      typeof fail.response.data.errors !== 'undefined') {
      let errors = fail.response.data.errors || []
      if (errors.length) {
        errors.forEach((e) => {
          Toast.open({message: e.detail, ...config})
        })
      } else {
        Toast.open({message: 'Si è verificato un errore.', ...config})
      }
    } else if (Array.isArray(fail)) {
      fail.forEach((e) => {
        Toast.open({message: e, ...config})
      })
    } else {
      console.log('There was an uncaught error:', fail)
      Toast.open({message: fail.toString(), ...config})
    }
  }
  /**
   * Get index of object inside an array by a value of its property.
   * @param {array} arr
   * @param {string} key
   * @param {any} value
   * @return {int}
   */
  static indexOfObject (arr, key, value) {
    return arr.indexOf(arr.find(e => e[key] === value))
  }
  /**
   * Get object contained in an array of object by a key and its value.
   * @param {array} arr
   * @param {string} key
   * @param {any} value
   * @return {object}
   */
  static objectByKey (arr, key, value) {
    let index = this.indexOfObject(arr, key, value)
    return index !== -1 ? arr[index] : null
  }
  /**
   * Return a copy of an object, to the deepest property, without references.
   * @param {any} obj
   * @return {any}
   */
  static copy (obj) {
    if (typeof obj === 'object') {
      return JSON.parse(JSON.stringify(obj)) // Object.assign({}, obj)
    }
    return obj
  }
  /**
   * Get the user-friendly activity status.
   * @param {string} status
   * @return {string}
   */
  static getActivityStatus (status) {
    switch (status) {
      case 'STARTED':
        return 'In corso'
      case 'SUSPENDED':
        return 'Sospesa'
      case 'INTERRUPTED':
        return 'Interrotta'
      case 'COMPLETED':
        return 'Completata'
      default:
      case 'PLANNED':
        return 'Pianificata'
    }
  }
  /**
   * Check if connection is up.
   * @return {Promise<T | never>}
   */
  static isOnline () {
    return client.options(`${process.env.API_BASE_URL}/api/v1`)
      .then(response => response.ok && navigator.onLine)
      .catch(() => false)
  }
  /**
   * Reset a variable basing on its type.
   * @param v
   * @return {*}
   */
  static reset (v) {
    if (typeof v === 'number') {
      return 0
    } else if (v === null) {
      return null
    } else if (typeof v === 'string') {
      return ''
    } else if (typeof v === 'object') {
      Object.keys(v).forEach(key => {
        v[key] = this.reset(v[key])
      })
      return v
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js